module.exports = __webpack_public_path__ + "static/media/account-landscape.ab1b4404.jpg";